import { OnboardingSubscriptionsStep } from "../types";
import OnboardingSubscriptionsContent from "./OnboardingSubscriptionsContent";

const OnboardingSubscriptionsPage = () => {
  return <OnboardingSubscriptionsContent id={null} step={OnboardingSubscriptionsStep.List} />;
};

export default OnboardingSubscriptionsPage;
